import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initAuthStorage, installSessionExpiryGuard } from './utils/auth';
import { API_URL } from './config/api';

/**
 * Browser extensions (e.g. Urban VPN) throw uncaught errors on the page.
 * CRA's overlay treats them as app crashes — ignore extension-originated noise in dev.
 */
if (process.env.NODE_ENV === 'development') {
  const isExtensionNoise = (value) => {
    const text = String(value || '');
    return (
      text.includes('chrome-extension://') ||
      text.includes('moz-extension://') ||
      text.includes("reading 'M_ID'") ||
      text.includes('reading "M_ID"')
    );
  };

  window.addEventListener(
    'error',
    (event) => {
      if (
        isExtensionNoise(event.filename) ||
        isExtensionNoise(event.message) ||
        isExtensionNoise(event.error?.stack)
      ) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      const reason = event.reason;
      if (isExtensionNoise(reason?.stack) || isExtensionNoise(reason?.message) || isExtensionNoise(reason)) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

initAuthStorage();
installSessionExpiryGuard(API_URL);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
